import PropTypes from 'prop-types';
var breadcrumbsI18nPropTypes = {
  breadcrumbs: PropTypes.string
};
export var item = {
  className: PropTypes.string,
  customItem: PropTypes.element,
  key: PropTypes.string,
  text: PropTypes.string.isRequired,
  url: PropTypes.string
};
export var breadcrumbItemInterface = {
  compact: PropTypes.bool,
  item: PropTypes.shape(item).isRequired,
  isFirstItem: PropTypes.bool,
  isLastItem: PropTypes.bool,
  truncateText: PropTypes.bool
};
var propTypes = {
  className: PropTypes.string,
  compact: PropTypes.bool,
  i18n: PropTypes.shape(breadcrumbsI18nPropTypes),
  items: PropTypes.arrayOf(PropTypes.shape(item).isRequired).isRequired,
  responsiveBreakpoint: PropTypes.string,
  truncateText: PropTypes.bool
};
export default propTypes;